
import { IonContent, IonPage, IonSpinner } from '@ionic/vue';
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'Login',
  data () {
    return {
      inserat: null,
      userMail: null,
      userPassword: null,
      isLoading: true,
    }
  },
  components: {
    IonContent,
    IonPage,
    IonSpinner
  },
  mounted() {

    // clear
    localStorage.clear();

    // clear
    window.dispatchEvent(new CustomEvent('user-state-changed', {
      detail: {
        userId: null,
        userName: null,
        userToken: null,
        userIsLoggedIn: false
      }
    }));

    // redirect to main screen
    this.$router.push({ path: '/login' })

  }
});

